/* 🤖 this file was generated by svg-to-ts */
export const matIconQueueMusic: {
  name: 'queue-music';
  data: string;
} = {
  name: 'queue-music',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 6h-5v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6zm-7 0H3v2h12V6zm0 4H3v2h12v-2zm-4 4H3v2h8v-2z"/></svg>`
};
